import {
  getFinancialActiveFinancials,
  getProductsByFinancialId,
  makeSimulation,
  makeSimulationBBVASpain,
  getSimulationBBVASpainTinAndPeriod,
  postEmail,
  postFin,
  saveCotation,
  getSellersTax,
  updateProposalData,
  getSellersBy
} from "@/api/simulation";
import Vue from "vue";
import i18n from "../../i18n";
import { disabledInputsByProduct } from "@/utils/simulation/disabledInputsByProduct";
//import { disabledInputsByFinancial } from "@/utils/simulation/disabledInputsByFinancial";
import { downloadFile } from "@/utils/documents";
import { validateUserInputs, validateSellersTaxPayload, validateInputsBeforeFetchSellersTax } from "@/utils/simulation/inputValidation";
//import { FUEL_REVERT } from "@/enums/fuel";
import { LOCALES } from "@/enums/locales";
import { yearsV2, monthsV2, daysV2, modalityV2, modalityNrV2, credityAssurance, credityAssuranceNr } from "@/utils/simulation/staticDropdownValues";
import { simulationToProposalForm } from '@/utils/simulation/simulationToProposalMapper';
import store from "@/store";
import {FINANCIAL_IDS} from "@/enums/financials/financialIds";
import {
  NOTARY_TRANSFER_FEE_CONFIG,
  resolveNotaryTransferFeeValue,
} from "@/utils/simulation/financialUtils";


/**
 * * Preselect language on change ********************************************************************************
 */

const locale = localStorage.getItem("locale");

if (locale) {
  i18n.locale = LOCALES[locale];
} else {
  i18n.locale = LOCALES["pt_pt"];
}

/**
 * * ********************************************************************************
 */

/**
 * * Validation logic on simulation
 */

function testIfItIsNotEmail(clientEmail) {
  if(!clientEmail || clientEmail.length > 200) {
    return false; 
  }

  // NOSONAR return !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(clientEmail);
  return !/^[\w.-]+@[\w.-]+\.\w{2,}$/.test(clientEmail);
}

const validationOnSimulation = (validation, commit) => {
  commit("setValidationBorderInitialState", {
    residualValue: false,
    rate: false,
    pvp: false,
    period: false,
    withBail: false,
    expenses: false,
    nrPayments: false,
    rateType: false,
    initialValueEur: false,
    carYear: false,
    ppcName: false,
    periodicity: false,
    nrPPCInsuredPeople: false,
    carType: false,
    periodBBVA: false,
    tin: false,
    fin: false,
    prod: false,
    vehicle: false,
    legalTax: false,
    birthdate: false,
    notaryTransferFees: false,
  });

  if (validation) {
    validation.map((item) => {
      console.log('item: ', item)
      launchErrorToast(item.errorMessage);
      state.validationBorder[item.parameter] = true;
    });
    return true;
  } else {
    return false;
  }
};

const isNotValidLetters = (str) => {
  // remove os acentos
  const strNormalize = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");  
  
  // RegEx Otimizada: Letras/espaços, opcionalmente seguidas por grupos que começam com um único delimitador e mais letras/espaços
  return !/^(?!\s*$)[a-zA-Zà-úÀ-Ú\s]+(?:[',.-][a-zA-Zà-úÀ-Ú\s]+)*$/.test(strNormalize);// NOSONAR - strNormalize controlados
};

/**
 * * Toast Error Message
 */

const launchErrorToast = (msg) => {
  Vue.$toast.open({
    message: msg,
    dismissible: true,
    type: "error",
  });
};

const launchSuccessToast = (msg) => {
  Vue.$toast.open({
    message: msg,
    dismissible: true,
    type: "success",
  });
};

const clearToasts = () => {
  Vue.$toast.clear()
};

const getSelectedCompanyId = (rootState) => {
  const authentication = rootState?.AuthenticationModule;
  const installationId = authentication?.instalationsDropdown?.find(
    item => item.selected
  )?.value;

  if (installationId == null) return undefined;

  return authentication?.rawInstalations?.find(
    item => Number(item.ID) === Number(installationId)
  )?.ID_ENTITYCOMPANY;
};

const getLegalTaxInvoicedTo = (simulationState, rootState) =>
  resolveNotaryTransferFeeValue(
    simulationState.financingInfo?.selectedFin?.value,
    simulationState.financingInfo?.notaryTransferFeesBillTheValue?.value,
    getSelectedCompanyId(rootState)
  );

const getDefaultState = () => {
  return {
    simulationPageKey: 1,
    hasSimulation: false,
    idCotation: -1,
    cotationData: null,
    financingInfo: {
      product: [],
      interestRate: { id: 1, value: i18n.t('pages.SimulatorPage.financingInfo.taxInfo.fixed') },
      periodicity: { id: 1, value: i18n.t('pages.SimulatorPage.financingInfo.periodocity.monthly') },
      pvp: 0,
      initialEntryPercentage: null,
      initialEntry: null,
      termMonths: 0,
      expenses: null,
      residualValuePercentage: 0,
      residualValue: 0,
      legalTax: 0,
      legalTaxInvoicedTo: "",
      tin: [{
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
      }],
      rateBtnList: [],
      periodocityBBVASpain: [{
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
      }],
      withBail: { id: 2, value: i18n.t('pages.SimulatorPage.financingInfo.bail.no') },
      openingCommission: 0,
      creditType: "",
      ppcV2: modalityV2,
      ppcNumberV2: modalityNrV2,
      credityAssurance: credityAssurance,
      credityAssuranceNr: credityAssuranceNr,
      period: "",
      rate: 0,
      withFinancedExpenses: { id: 2, value: i18n.t('pages.SimulatorPage.financingInfo.withFinancedExpenses.no') },
      withFinancedTax: { id: 2, value: i18n.t('pages.SimulatorPage.financingInfo.withFinancedTax.no') },
      selectedFin: {
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
        expensesFinance: -1,
        taxStampFinance: -1,
        monthToBeUsed: -1,
      },
      selectedProd: {
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
      },
      ppcValue: {
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
      },
      ppcNrValue: {
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
      },
      credityAssuranceValue: {
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
      },
      credityAssuranceNrValue: {
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
      },
      notaryTransferFeesBillTheValue: {
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
      },
      notaryTransferFeesBillThe: [
        {
          value: '-1',
          text: i18n.t('dropdownSelection'),
          disabled: true,
        },
        {
          value: 'Suportado Parceiro',
          text: i18n.t('Suportado Parceiro'),
        },
        {
        value: 'Cliente - abertura ATM',
        text: i18n.t('Cliente - abertura ATM'),
        },
        {
        value: 'Cliente - Financiado',
        text: i18n.t('Cliente - Financiado'),
        }
      ],
      bbvaTinKey: 1
    },
    vehicleInfo: {
      vehicleCondition: { id: 1, value: i18n.t('pages.SimulatorPage.vehicleInfo.vehicleCondition.new') },
      daysV2: daysV2,
      monthsV2: monthsV2,
      yearsV2: yearsV2,
      plateYear: {
        value: -1,
        text: "Ano",
        disabled: true,
      },
      plateMonth: {
        value: -1,
        text: i18n.t('pages.SimulatorPage.vehicleInfo.plateDropdown.plateMonth'),
        disabled: true,
      },
      plateDay: {
        value: -1,
        text: i18n.t('pages.SimulatorPage.vehicleInfo.plateDropdown.plateDay'),
        disabled: true,
      },
      vehicleType: "",
      brand: "",
      model: "",
      modelExt: "",
      version: "",
      euroTaxCode: "",
      grossWeight: "",
      fuel: "",
      enginePower: "",
      displacementEngine: "",
      doors: "",
      places: ""
    },
    clientInfo: {
      clientType: 1,
      name: "",
      firstName: "",
      firstSurname: "",
      secondSurname: "",
      birthdate: "",
      birthdateError: false,
      phoneNumber: "",
      email: "",
      seller: "",
      notes: "",
      clientTypeArray: [
        {
          id: 1,
          label: i18n.t(
            "pages.SimulatorPage.clientInfo.clientType.individual"
          ),
          value: true,
          isENICompany: false,
          disabled: false
        },
        {
          id: 3,
          label: i18n.t("pages.SimulatorPage.clientInfo.clientType.company"),
          value: false,
          isENICompany: false,
          disabled: false
        },
        {
          id: 2,
          label: i18n.t(
            "pages.SimulatorPage.clientInfo.clientType.eniIndividual"
          ),
          value: false,
          isENICompany: false,
          disabled: false
        },
        {
          id: 2,
          label: i18n.t(
            "pages.SimulatorPage.clientInfo.clientType.enicOMPANY"
          ),
          value: false,
          isENICompany: true,
          disabled: false
        },
      ],
      clientTypeBBVA:
        [
          {
            id: 1,
            label: i18n.t(
              "pages.SimulatorPage.clientInfo.clientType.individual"
            ),
            value: true,
            isENICompany: false
          },
          {
            id: 4,
            label: i18n.t(
              "pages.SimulatorPage.clientInfo.clientType.autonomous"
            ),
            value: false,
            isENICompany: false
          }
        ],
      clientTypeLabel: "Particular",
      isENICompany: false,
      emailValidationBorder: false,
    },
    sellerInfo: {
      sellers: [],
      seller: '',
      emailSeller: '',
      value: -1
    },
    simulationResults: {
      nominalAmount: 0,
      share: 0,
      openingCommissionAmount: 0,
      shippingTaxes: 0,
      tae: 0,
      creditInsuranceType: 0,
      initialEntry: 0,
      capitalToFinance: 0,
      feeWithoutInsurence: 0,
      initialExpenses: 0,
      taxStamp: 0,
      portsExpenses: 0,
      taeg: 0,
      singlePPCValue: 0,
      firstPayment: 0,
      period: 0,
      fee: 0,
      cleanRewardFinancial: 0,
      cleanRewardInitialExpenses: 0,
      cleanPPCRewardTotalValue: 0,
      PPCReward: 0,
      initialExpensesMinimun: 0,
      residualValueMaximum: 0,
      euribor: 0,
      spread: 0,
      finacialIdCalculated: 0
    },
    activeFinancialV2: [{
      value: -1,
      text: i18n.t('dropdownSelection'),
      disabled: true,
    },],
    activeProductsV2: [{
      value: -1,
      text: i18n.t('dropdownSelection'),
      disabled: true,
    },],
    vehicleCategories: [],
    vehicleBrands: [],
    activeProductsWithExpenses: [],
    modalities: [],
    validationBorder: {
      residualValue: false,
      rate: false,
      pvp: false,
      period: false,
      withBail: false,
      expenses: false,
      nrPayments: false,
      rateType: false,
      initialValueEur: false,
      carYear: false,
      ppcName: false,
      periodicity: false,
      nrPPCInsuredPeople: false,
      carType: false,
      periodBBVA: false,
      tin: false,
      fin: false,
      prod: false,
      vehicle: false,
      legalTax: false,
      birthdate: false,
      notaryTransferFees: false,
    },
    bbvaSpain: false,
    isBBVAResults: false,
    sellersStuff: {
      payloadClone: {}
    },
    simulationToProposalForm: {},
    isClientInfoDisable: false,
    disabledInputsByFinancial: {},
    disabledInputsWithDefaultValue: {},
    disabledInputsByProduct: {},
    defaultValue: {},
    isSellerInfoDisable: false,
    containsChanges: false,
    isInicialValues: true,
    phoneNumberPrefix: '+351',
  };
}

const state = getDefaultState();

const getters = {
  getSimulationKey: (state) => state.simulationPageKey,
  getHasSimulation: (state) => state.hasSimulation,
  //* Vehicle Data Form
  getVehicleInfo: (state) => state.vehicleInfo,
  getVehicleInfoWithKey: (state) => (key) => state.vehicleInfo[key],
  //* Client Data Form
  getClientInfo: (state) => state.clientInfo,
  getClientInfoWithKey: (state) => key => state.clientInfo[key],
  getIsClientInfoDisable: (state) => state.isClientInfoDisable,
  getClientEmail: (state) => state.clientInfo.email,
  //* Result Data Form
  getSimulationResults: (state) => state.simulationResults,
  getSimulationResultsWithKey: (state) => (key) => state.simulationResults[key],
  getSimulationResultsBPINote: () => {
    return i18n.t('pages.SimulatorPage.simulationResults.withResults.modalityNotes.bpiNote')
  },
  getSimulationResultsModality: (state) => {
    return i18n.tc('pages.SimulatorPage.simulationResults.withResults.modalityNotes.initialPayment', state.simulationResults?.firstPayment, {
      firstPayment: state.simulationResults?.firstPayment,
    }) + i18n.tc('pages.SimulatorPage.simulationResults.withResults.modalityNotes.period', state.simulationResults?.period, {
      period: state.simulationResults?.period,
    }) + i18n.tc('pages.SimulatorPage.simulationResults.withResults.modalityNotes.periodPayment', state.simulationResults?.fee, {
      fee: state.simulationResults?.fee,
    })
  },
  getSimulationResultsInternalRef: (state) => {
    return `GSC - [F:${state.simulationResults?.cleanRewardFinancial}] [D:${state.simulationResults?.cleanRewardInitialExpenses}] [PPC:${state.simulationResults?.cleanPPCRewardTotalValue}]`;
  },
  getSimulationResultsNotes: (state) => {
    return i18n.tc('pages.SimulatorPage.simulationResults.withResults.notesMessage.minExpenses', state.simulationResults?.initialExpensesMinimun, {
      firstPayment: state.simulationResults?.initialExpensesMinimun,
    }) + i18n.tc('pages.SimulatorPage.simulationResults.withResults.notesMessage.residualValue', state.simulationResults?.residualValueMaximum, {
      residualValueMaximum: state.simulationResults?.residualValueMaximum,
    }) + i18n.tc('pages.SimulatorPage.simulationResults.withResults.notesMessage.euribor', state.simulationResults?.euribor, {
      euribor: state.simulationResults?.euribor,
    }) + i18n.tc('pages.SimulatorPage.simulationResults.withResults.notesMessage.spread', state.simulationResults?.spread, {
      spread: state.simulationResults?.spread,
    })
  },
  getSimulationResultsFinancialId: (state) => state.simulationResults.finacialIdCalculated,
  //* Financial Data Form
  getActiveFinancialDropdownV2: (state) => state.activeFinancialV2,
  getActiveProductsDropdownV2: (state) => state.activeProductsV2,
  getFinancingInfo: (state) => state.financingInfo,
  getFinancingInfoWithKey: (state) => (key) => state.financingInfo[key],
  getVehicleCategories: (state) => state.vehicleCategories,
  getVehicleBrands: (state) => state.vehicleBrands,
  getModalityDropdownV2: (state) => state.financingInfo.ppcV2,
  getModalityNrDropdownV2: (state) => state.financingInfo.ppcNumberV2,
  getActiveExpenses: (state) => state.activeProductsWithExpenses,
  getModalities: (state) => state.modalities,
  getIsInputDisabledV2: (state) => (input) => {
    const selectedFinancial = state.financingInfo.selectedFin;
    const selectedProduct = state.financingInfo.selectedProd;
    const disabledInputsByFinancial2 = state.disabledInputsByFinancial; //disabledInputsByFinancial;
    const disabledInputsByProduct2 = state.disabledInputsByProduct;
    
    if (selectedFinancial?.value !== -1 && selectedProduct?.value !== -1) {
      const isDisabledByFinancial = disabledInputsByFinancial2[input][selectedFinancial?.text];
      let isDisabledByProduct = false;

      if(input === 'withFinancedExpenses') {
        isDisabledByProduct = disabledInputsByProduct2[input][selectedProduct?.text];
      } else {
        isDisabledByProduct = disabledInputsByProduct[input][selectedProduct?.text];
      }

      if(input === 'withFinancedTax') {
        return isDisabledByFinancial;
      }
      
      //const isDisabledByProduct = disabledInputsByProduct[input][selectedProduct?.text];
      
      return isDisabledByProduct || isDisabledByFinancial;
    } else {
      return true;
    }
  },
  getDfValue: (state) => {
    return state.financingInfo.withFinancedExpenses?.id === 2
      ? "right"
      : "left";
  },
  getIfValue: (state) => {
    return state.financingInfo.withFinancedTax?.id === 2
      ? "right"
      : "left";
  },
  getBailValue: (state) => {
    return state.financingInfo.withBail?.id === 2
      ? "right"
      : "left";
  },
  //* Validation Border
  getValidationBorderByKey: (state) => (key) => state.validationBorder[key],
  //* BBVA Spain
  getIsBBVASpain: (state) => state.bbvaSpain,
  getIsBBVASpainResults: (state) => state.isBBVAResults,
  getProposalFormat: (state) => state.simulationToProposalForm,
  getDisabledInputsWithDefaultValue: (state) => state.disabledInputsWithDefaultValue,
  getInputDefaultValue: (state) => state.defaultValue,
  getSellers: (state) => state.sellerInfo.sellers,
  getSellerInfoWithKey: (state) => key => state.sellerInfo[key],
  getSellerEmail: (state) => state.sellerInfo.emailSeller,
  getIsSellerInfoDisable: (state) => state.isSellerInfoDisable,
  getContainsChanges: (state) => state.containsChanges,
  isInicialValues: (state) => state.isInicialValues,
  getIdCotation: (state) => state.idCotation,
  getPhoneNumberPrefix: (state) => state.phoneNumberPrefix,
  getNotaryTransferFeesBillTheV1: (state) => state.financingInfo.notaryTransferFeesBillThe,
  getNotaryTransferFeesBillThe: (state, getters, rootState) => {
    const financialId = Number(state.financingInfo.selectedFin?.value);
    const config = NOTARY_TRANSFER_FEE_CONFIG[financialId];

    const placeholder = {
      value: "-1",
      text: i18n.t("dropdownSelection"),
      disabled: true,
    };

    if (!config) {
      return [placeholder];
    }

    const hasFixedValue = config.fixedValue != null;
    let fixedValue = config.fixedValue;

    if (hasFixedValue) {
      const authentication = rootState.AuthenticationModule;
      const selectedEntity = authentication.instalationsDropdown.find(
        item => item.selected
      );
      const entity = authentication.rawInstalations.find(
        item => Number(item.ID) === Number(selectedEntity?.value)
      );
      const companyId = entity?.ID_ENTITYCOMPANY;

      if (companyId == null || companyId === "") {
        return [placeholder];
      }

      fixedValue =
        config.fixedValueByCompany?.[Number(companyId)] ??
        config.fixedValue;
    }

    const selectedValue = hasFixedValue
      ? fixedValue
      : state.financingInfo.notaryTransferFeesBillTheValue?.value;

    return [
      placeholder,
      ...config.options.map(value => ({
        value,
        text: i18n.t(value),
        selected: value === selectedValue,
      })),
    ];
  },
  getIsNotaryTransferFeesLocked: (state) => {
    const financialId = Number(state.financingInfo.selectedFin?.value);
    return NOTARY_TRANSFER_FEE_CONFIG[financialId]?.fixedValue != null;
  },
};

const mutations = {
  setSimulationKey(state) {
    state.simulationPageKey = crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296;
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  setHasSimulation(state, hasSimulation) {
    state.hasSimulation = hasSimulation;
  },
  setContainsChanges(state, containsChanges) {
    state.containsChanges = containsChanges;
  },
  setIsInicialValues(state, isInicialValues) {
    state.isInicialValues = isInicialValues;
  },
  setIsClientInfoDisable(state, isClientInfoDisable) {
    state.isClientInfoDisable = isClientInfoDisable;
  },
  setIsSellerInfoDisable(state, isSellerInfoDisable) {
    state.isSellerInfoDisable = isSellerInfoDisable;
  },
  setActiveFinancialDropdown(state, activeFinancial) {
    state.activeFinancialV2 = activeFinancial;
  },
  setActiveProductDropdownv2(state, activeProducts) {
    state.activeProductsV2 = activeProducts;
  },
  setSellers(state, activeSellers) {
    state.sellerInfo.sellers = activeSellers;
  },
  setEmailSeller(state, emailSeller) {
    state.sellerInfo.emailSeller = emailSeller;
  },
  setActiveFinancialDropdownV2(state, activeFinancial) {
    var newArrayOfObjDropdown = activeFinancial.map(
      ({ ID: value, NAME: text, TAXSTAMP_FINANCE: taxStampFinance, EXPENSES_FINANCE: expensesFinance, MONTH_TO_BE_USED_CAR:monthToBeUsedCar }) => ({
        value,
        text,
        expensesFinance,
        taxStampFinance,
        monthToBeUsedCar
      })
    );

    newArrayOfObjDropdown = [
      {
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
      },
      ...newArrayOfObjDropdown,
    ];

    state.activeFinancialV2 = newArrayOfObjDropdown;
  },
  setDisabledInputsByFinancial(state, activeFinancial) {
    const withFinancedExpenses = activeFinancial.reduce((accumulator, obj) => {
      accumulator[obj.NAME] = obj.EXPENSES_FINANCE === 1 || obj.EXPENSES_FINANCE === -1;
      return accumulator;
    }, {});

    const withFinancedTax = activeFinancial.reduce((accumulator, obj) => {
      accumulator[obj.NAME] = obj.TAXSTAMP_FINANCE === 1 || obj.TAXSTAMP_FINANCE === -1;
      return accumulator;
    }, {});
    
    const disabledInputs = {};
    disabledInputs['withFinancedExpenses'] = withFinancedExpenses;
    disabledInputs['withFinancedTax'] = withFinancedTax;

    state.disabledInputsByFinancial = disabledInputs;
  },
  setDisabledInputsAndSetDefaultValue(state, activeFinancial) {
    const withFinancedExpenses = activeFinancial.reduce((accumulator, obj) => {
      accumulator[obj.NAME] = obj.EXPENSES_FINANCE;
      return accumulator;
    }, {});

    const withFinancedTax = activeFinancial.reduce((accumulator, obj) => {
      accumulator[obj.NAME] = obj.TAXSTAMP_FINANCE;
      return accumulator;
    }, {});
    
    const withDefaultValue = {};
    withDefaultValue['withFinancedExpenses'] = withFinancedExpenses;
    withDefaultValue['withFinancedTax'] = withFinancedTax;

    state.disabledInputsWithDefaultValue = withDefaultValue;
  },
  setDisabledInputsByProduct(state, data) {
    const withFinancedExpenses = data?.reduce((accumulator, obj) => {
      const expenses = obj?.EXPENSES[0] || {}; 
      const key = obj.NAME.toString()
      accumulator[key] = expenses?.EXPENSES_FINANCE === 1 || expenses?.EXPENSES_FINANCE === -1;
      return accumulator;
    }, {});

    const financedExpensesDefaultValue = data?.reduce((accumulator, obj) => {
      const expenses = obj?.EXPENSES[0] || {}; 
      const key = obj.NAME.toString()
      accumulator[key] = expenses?.EXPENSES_FINANCE|| 0;
      return accumulator;
    }, {});
    
    const disabledInputs = {};
    disabledInputs['withFinancedExpenses'] = withFinancedExpenses;
    state.disabledInputsByProduct = disabledInputs;

    const defaultValue = {};
    defaultValue['withFinancedExpenses'] = financedExpensesDefaultValue;
    state.defaultValue = defaultValue;
  },
  setActiveProductsDropdownV2(state, activeProducts) {
    var newArrayOfObjDropdown = activeProducts.map(
      ({ ID: value, NAME: text, EXPENSES: expenses, EXPENSES_LEGALIZATION: legalExpenses, TAXSTAMP_FINANCE: taxStampFinance, EXPENSES_FINANCE: expensesFinance }) => ({
        value,
        text,
        expenses,
        legalExpenses,
        expensesFinance,
        taxStampFinance
      })
    );
    state.activeProductsWithExpenses = newArrayOfObjDropdown;
    newArrayOfObjDropdown = [
      {
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
      },
      ...newArrayOfObjDropdown,
    ];
    state.activeProductsV2 = newArrayOfObjDropdown;
  },
  //* Vehicle Data Form
  setVehicleInfo(state, vehicleInfo) {
    state.vehicleInfo = vehicleInfo;
  },
  setVehicleInfoField(state, vehicleInfoField) {
    state.vehicleInfo[vehicleInfoField?.field] = vehicleInfoField.value;
  },
  setVehicleInfoFromVersion(state, vehicleInfoField) {
    state.vehicleInfo = { ...state.vehicleInfo, ...vehicleInfoField };
  },
  setVehicleCategories(state, vehicleCategories) {
    const categories = [];
    Object.keys(vehicleCategories).forEach((element, index) => {
      categories.push({ key: index, value: element });
    });
    state.vehicleCategories = categories;
  },
  setVehiclePlainCategories(state, vehicleCategories) {
    state.vehicleCategories = vehicleCategories;
  },
  setVehicleBrands(state, vehicleBrands) {
    state.vehicleBrands = vehicleBrands;
  },
  //* Client Data Form
  setClientInfo(state, clientInfo) {
    state.clientInfo = clientInfo;
  },
  setClientInfoField(state, clientInfoField) {
    
    if(clientInfoField?.field === 'clientType') {
      store.commit("SimulationModule/setHasSimulation", false);
      store.commit("SimulationModule/setContainsChanges", clientInfoField?.hasChange || false);
    }
    state.clientInfo[clientInfoField?.field] = clientInfoField.value;
  },
  setSellerInfoField(state, sellerInfoField) {
    state.sellerInfo[sellerInfoField?.field] = sellerInfoField.value;
  },
  setSellersDropdown(state, { sellers, sellerName }) {
    var newArrayOfObjDropdown = sellers?.map(({
        ID: value,
        NAME: text,
        EMAIL: email
    }) => ({
        value,
        text,
        email
    }));

    newArrayOfObjDropdown = [
      {
          value: -1,
          text: i18n.t("dropdownSelection"),
          email: '',
          disabled: true,
      },
      ...newArrayOfObjDropdown,
    ];

    if(newArrayOfObjDropdown.length > 1) {
      newArrayOfObjDropdown = newArrayOfObjDropdown.map((item) => {
        item.selected = (item.text === sellerName);
        return item;
      });

      if(sellerName === '') {
        newArrayOfObjDropdown[1].selected = true;
      } 

      const selectedSeller = newArrayOfObjDropdown.find((item) => item.selected);
      store.commit("SimulationModule/setSellerInfoField", { field: 'seller', value: selectedSeller?.text || '' });
      store.commit("SimulationModule/setSellerInfoField", { field: 'value', value: selectedSeller?.value || -1 });
      store.commit("SimulationModule/setSellerInfoField", { field: 'emailSeller', value: selectedSeller?.email || '' });
    }

    state.sellerInfo.sellers = newArrayOfObjDropdown;
  },
  //* Result Data Form
  setSimulationResults(state, simulationResults) {
    state.simulationResults = simulationResults;
  },
  setSimulationResultsField(state, simulationResults) {
    state.simulationResults[simulationResults?.field] = simulationResults.value;
  },
  setSimulationResultsFinancialId(state, finacialIdCalculated) {
    state.simulationResults.finacialIdCalculated = finacialIdCalculated;
  },
  //* Financial Data Form
  setFinancingInfo(state, financingInfo) {
    state.financingInfo = financingInfo;
  },
  setFinancingInfoField(state, financingInfoField) {
    store.commit("SimulationModule/setHasSimulation", false);
    
    if(!state.isInicialValues) { 
      store.commit("SimulationModule/setContainsChanges", true);
    }
    
    state.financingInfo[financingInfoField?.field] = financingInfoField.value;
  },
  setFinancingInfoEntry(state, entry) {
    if (entry?.field == "initialEntryPercentage") {
      state.financingInfo["initialEntryPercentage"] = entry.value;
      state.financingInfo["initialEntry"] =
        (entry.value * state.financingInfo.pvp) / 100;
    } else {
      state.financingInfo["initialEntryPercentage"] = (
        (entry.value / state.financingInfo.pvp) *
        100
      ).toFixed(2);
      if (Number(entry.value) > Number(state.financingInfo.pvp)) {
        state.financingInfo["initialEntryPercentage"] = 0;
        state.financingInfo["initialEntry"] = 0;
        Vue.$toast.open({
          message: `Entrada Inicial superior ao pvp`,
          dismissible: true,
          type: "error",
        });
      } else {
        state.financingInfo["initialEntry"] = entry.value;
      }

    }

    store.commit("SimulationModule/setHasSimulation", false);
    store.commit("SimulationModule/setContainsChanges", entry?.hasChange || false);
  },
  setFinancingInfoExpenses(state, entry) {
    if (!state.financingInfo.pvp || state.financingInfo.pvp === 0) {
      Vue.$toast.open({
        message: `Introduzir valor de PVP`,
        dismissible: true,
        type: "error",
      });
    }
    if (entry?.field == "residualValuePercentage") {
      state.financingInfo["residualValuePercentage"] = entry.value;
      state.financingInfo["residualValue"] =
        (entry.value * state.financingInfo.pvp) / 100;
    } else {
      state.financingInfo["residualValuePercentage"] = (
        (entry.value / state.financingInfo.pvp) *
        100
      ).toFixed(2);
      if (state.financingInfo["residualValuePercentage"] > 100) {
        state.financingInfo["residualValuePercentage"] = 0;
        state.financingInfo["residualValue"] = 0;
      } else {
        state.financingInfo["residualValue"] = entry.value;
      }
    }

    store.commit("SimulationModule/setHasSimulation", false);
  },
  setFinancingInfoPvp(state, pvp) {
    state.financingInfo["initialEntryPercentage"] = 0;
    state.financingInfo["initialEntry"] = 0;
    state.financingInfo.pvp = pvp;

    store.commit("SimulationModule/setHasSimulation", false);
    store.commit("SimulationModule/setContainsChanges", true);
  },
  setFinancingInfoInitialExpenses(state, expenses) {
    // state.financingInfo["residualValuePercentage"] = 0;
    // state.financingInfo["residualValue"] = 0;
    state.financingInfo.expenses = expenses;
  },
  setFinancingInfoModality(state, modality) {
    state.modality = modality;
  },
  setFinancingInfoModalityNr(state, modalityNr) {
    state.modalityNr = modalityNr;
  },
  setIdCotation(state, idCotation) {
    state.idCotation = idCotation;
  },
  setCotationData(state, cotationData) {
    state.cotationData = cotationData;
  },
  setPeriodDropdown(state, period) {
    state.period = period;
  },
  setModalities(state, modalities) {
    state.modalities = modalities;
  },
  //* Validation Border
  setValidationBorderInitialState(state, validationBorder) {
    state.validationBorder = validationBorder;
  },
  //* BBVA Spain
  setIsBBVASpain(state, isBBVASpain) {
    state.bbvaSpain = isBBVASpain;
  },
  setIsBBVAResults(state, isBBVAResults) {
    state.isBBVAResults = isBBVAResults;
  },
  setBBVATin(state, tin) {
    let tinObjArray = tin ? tin.map((item) => {
      return { value: item.id, text: item.percentage.toString() };
    }) : {};
    const colors = {
      0: "green-btn",
      1: "yellow-btn",
      2: "red-btn",
    };
    const rateBtnList = [];

    if (tin) {
      tinObjArray.map((tin, index) => {
        rateBtnList.push({
          key: Number(tin?.value),
          color: colors[index],
          value: Number(tin?.text)
        });
      });
    }

    tinObjArray = tin ? [
      {
        value: -1,
        text: i18n.t('pages.SimulatorPage.Financing.tinSelection'),
        disabled: true,
      },
      ...tinObjArray,
    ] : [
      {
        value: -1,
        text: i18n.t('pages.SimulatorPage.Financing.tinSelection'),
        disabled: true,
      },
    ];

    state.financingInfo.rateBtnList = rateBtnList;
    state.financingInfo.tin = tinObjArray;
  },
  setBBVAPeriodocity(state, periodocityBBVASpain) {
    let periodocityObjArray = periodocityBBVASpain?.map((item) => {
      return { value: item, text: item.toString() };
    });

    periodocityObjArray = [
      {
        value: -1,
        text: i18n.t('pages.SimulatorPage.Financing.periodSelection'),
        disabled: true,
      },
      ...periodocityObjArray,
    ];

    state.financingInfo.periodocityBBVASpain = periodocityObjArray;
  },
  setSellersPayloadClone(state, payloadClone) {
    state.sellersStuff.payloadClone = payloadClone;
  },
  setProposalFormat(state) {
    state.simulationToProposalForm = simulationToProposalForm(state, store.getters["AuthenticationModule/getInstalationSelected"], store.getters["AuthenticationModule/getUserName"], store.getters["ProposalsModule/getBMDropdown"]);
  },
  setProposalFormatRaw(state, simulationToProposalForm) {
    state.simulationToProposalForm = simulationToProposalForm;
  },
  setPhoneNumberPrefix(state, phoneNumberPrefix) {
    state.phoneNumberPrefix = phoneNumberPrefix;
  }
};

const choosePeriodocityAndTinByCompanyAndVehicle = (periodocity, tins, commit) => {
  const idSelFinancial = state.financingInfo.selectedFin?.value;
  const isVehicleUsed = state.vehicleInfo.vehicleCondition?.id === 2 ? true : false;
  const monthToBeUsed = state.activeFinancialV2?.find(item => item.value == idSelFinancial)?.monthToBeUsedCar;

  const monthDiff = (d1, d2) => {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  const isBBVASpain = state.bbvaSpain;
  state.financingInfo.rate = isBBVASpain ? -1 : state.financingInfo.rate;
  state.financingInfo.period = isBBVASpain ? -1 : state.financingInfo.period;

  const commitPeriodocityAndTinsByVehicleUses = (finTagNew, finTagUsed, monthsThreshold) => {
    if (isVehicleUsed && state.vehicleInfo?.plateYear?.value !== -1) {
      const carMonth = state.vehicleInfo?.plateMonth?.value !== -1 ? Number(state.vehicleInfo?.plateMonth?.text) : 1;
      const carYear = Number(state.vehicleInfo?.plateYear?.text);

      if (monthDiff(new Date(carYear, carMonth - 1, 1), new Date()) > monthsThreshold) {
        commit("setBBVATin", tins[finTagUsed]);
        commit("setBBVAPeriodocity", periodocity[finTagUsed]);
      } else {
        commit("setBBVATin", tins[finTagNew]);
        commit("setBBVAPeriodocity", periodocity[finTagNew]);
      }

    } else if (isVehicleUsed && state.vehicleInfo?.plateYear?.value === -1) {
      commit("setBBVATin", []);
      commit("setBBVAPeriodocity", []);
    } else {
      commit("setBBVATin", tins[finTagNew]);
      commit("setBBVAPeriodocity", periodocity[finTagNew]);
    }
  };
  const monthsThresholdBBVA = monthToBeUsed || 84;
  const monthsThresholdSofinco = monthToBeUsed || 96;
  const monthsThresholdCaixabank = monthToBeUsed || 96;
  const monthsThresholdCetelemEs = monthToBeUsed || 85;
  const monthsThresholdSabadell = monthToBeUsed || 72;
  const monthsThresholdSantanderEs = monthToBeUsed || 84;

  const idFinancial = Number(idSelFinancial);
  switch (idFinancial) {
    case 12:
      commitPeriodocityAndTinsByVehicleUses('12#N', '12#U', monthsThresholdBBVA);
      state.financingInfo.bbvaTinKey += 1;
      break;
    case 13:
      commitPeriodocityAndTinsByVehicleUses('13#N', '13#U', monthsThresholdSofinco);
      state.financingInfo.bbvaTinKey += 1;
      break;
    case 15:
      commitPeriodocityAndTinsByVehicleUses('15#N', '15#U', monthsThresholdCaixabank);
      state.financingInfo.bbvaTinKey += 1;
      break;
    case 16:
      commitPeriodocityAndTinsByVehicleUses('16#N', '16#U', monthsThresholdCetelemEs);
      state.financingInfo.bbvaTinKey += 1;
      break;
    case 17:
      commitPeriodocityAndTinsByVehicleUses('17#N', '17#U', monthsThresholdSabadell);
      state.financingInfo.bbvaTinKey += 1;
      break;
    case 18:
      commitPeriodocityAndTinsByVehicleUses(`${idFinancial}#N`, `${idFinancial}#U`, monthsThresholdSantanderEs);
      state.financingInfo.bbvaTinKey += 1;
      break;
    default:
  }

}

const actions = {
  resetSimulationState({ commit }) {
    commit('resetState');
  },
  async fetchFinancialActiveFinancials({ commit }) {

    try {
      const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;
      const response = await getFinancialActiveFinancials(idInstance);
     
      commit("setActiveFinancialDropdownV2", response?.data?.data);
      commit("setDisabledInputsByFinancial", response?.data?.data);
      commit("setDisabledInputsAndSetDefaultValue", response?.data?.data);
      commit("setModalities", response?.data?.data);

    } catch (error) {
      console.log(error);
    }

  },
  async fetchActiveProducts({ commit }, { id, idCurrentEntity }) {

    try {
      const response = await getProductsByFinancialId(id, idCurrentEntity);
      commit("setActiveProductsDropdownV2", response?.data?.data);
      commit("setDisabledInputsByProduct", response?.data?.data);

    } catch (error) {
      console.log(error);
    }

  },
  async fetchTinAndPeriodBBVASpain({ commit }, id) {

    try {
      const response = await getSimulationBBVASpainTinAndPeriod(id);

      const timePeriods = response?.data?.data?.timePeriods;
      const tins = response?.data?.data?.tins;

      choosePeriodocityAndTinByCompanyAndVehicle(timePeriods, tins, commit);
    } catch (error) {
      console.log(error);
    }

  },
  async fetchSellers({ commit }, { idEntity, sellerName }) {

    try {
      const response = await getSellersBy(idEntity);

      commit("setSellersDropdown", { sellers: response?.data?.data || [], sellerName: sellerName });
    } catch (error) {
      console.log(error);
    }
  },
  async calculateSimulation({ commit, rootState }) {
    const userId = rootState.AuthenticationModule.userDetails?.ID;
    const userProfileId = rootState.AuthenticationModule.userDetails?.ID_PROFILE;

    const instalationId =
      rootState.AuthenticationModule.instalationsDropdown.find(
        (item) => item.selected
      )?.value;

    const idSelFinancial = state.financingInfo.selectedFin?.value;
    const idProduct = state.financingInfo.selectedProd?.value;

    const ppc = state.financingInfo.ppcValue;
    const ppcNumber = state.financingInfo.ppcNrValue;

    const isVehicleUsed =
      state.vehicleInfo.vehicleCondition?.id === 2 ? true : false;

    const isBBVASpain = state.bbvaSpain;

    state.isBBVAResults = isBBVASpain;

    /*state.financingInfo.withFinancedExpenses = isBBVASpain
      ? { id: 1, value: i18n.t("pages.SimulatorPage.financingInfo.withFinancedExpenses.yes") }
      : state.financingInfo?.withFinancedExpenses;*/


    if (validateUserInputs(idProduct, idSelFinancial, state, userProfileId)) {
      return;
    }

    if (!validateSellersTaxPayload(state, userProfileId, rootState) && !isBBVASpain) {
      launchErrorToast("Calcular novamente taxa de juro");
      return;
    }

    const clientBirthdate = state.clientInfo?.birthdate;
    const carPlateDay = state.vehicleInfo?.plateDay?.text;

    try {
      const payload = {
        financialInfo: {
          idUser: userId,
          idSelFinancial: Number(idSelFinancial),
          idProduct: Number(idProduct),
          idCurrentEntity: Number(instalationId),
          rateType: state.financingInfo?.interestRate?.id === 1 ? "Fixa" : "Indexada",
          periodicity: state.financingInfo?.periodicity?.id === 1 ? "Mensal" : "Trimestral",
          pvp: Number(state.financingInfo?.pvp),
          initialValueEur: Number(state.financingInfo?.initialEntry),
          nrPayments: Number(state.financingInfo?.period),
          rate: Number(state.financingInfo?.rate),
          ...(!isBBVASpain && {
            residualValue:
              state.financingInfo?.residualValue == ""
                ? 0
                : Number(state.financingInfo?.residualValue),
          }),
          ...(!isBBVASpain && { lackPeriod: 0 }),
          ...(!isBBVASpain && { differentialFeeNrMonths: 0 }),
          ...(!isBBVASpain && { differentialFeeValue: 0 }),
          expenses: Number(state.financingInfo?.expenses),
          legalTax: Number(state.financingInfo?.legalTax),
          legalTaxInvoicedTo: getLegalTaxInvoicedTo(state, rootState),
          ppcName: ppc.value === -1 ? "" : ppc.text,
          nrPPCInsuredPeople:
            ppcNumber.value === -1 ? 0 : Number(ppcNumber.text),
          expensesFinance:
            state.financingInfo?.withFinancedExpenses.id === 1
              ? "S"
              : "N",
          taxStampFinance:
            state.financingInfo?.withFinancedTax.id === 1
              ? "S"
              : "N",
          ...(!isBBVASpain && {
            withBail:
              state.financingInfo?.withBail.id === 1
                ? "S"
                : "N",
          }),
        },
        vehicleInfo: {
          carType:
            state.vehicleInfo.vehicleCondition?.id === 1
              ? "Novo"
              : "Usado",
          brand: state.vehicleInfo?.brand,
          ...(isVehicleUsed && { carYear: state.vehicleInfo?.plateYear?.text }),
          ...(isVehicleUsed && {
            carMonth: state.vehicleInfo?.plateMonth?.text,
          }),
          ...(isVehicleUsed && {
            carDay: (isNaN(carPlateDay) || carPlateDay == '') ? 1 : carPlateDay,
          }),
          maintenanceContract: 0,
          warrantyExtra: 0,
          grossWeight: state.vehicleInfo?.grossWeight || 0,
        },
        clientInfo: {
          originalClientType: state.clientInfo?.clientType,
          isENICompany: state.clientInfo?.isENICompany,
          ...(clientBirthdate && { clientBirthdate: clientBirthdate }),
        },
      };

      const response = isBBVASpain
        ? await makeSimulationBBVASpain(payload)
        : await makeSimulation(payload);
      const responseData = response?.data?.data;
      const validations = responseData?.validations;

      if(responseData) {
        if (validationOnSimulation(validations, commit)) {
          state.hasSimulation = false;
        } else {
          commit("setSimulationResults", responseData);
          state.hasSimulation = true;
          store.commit("SimulationModule/setIsInicialValues", false);
        }
      }

      if (response?.response?.data?.statusCode === 500) {
        launchErrorToast(response?.response?.data?.message);
        state.hasSimulation = false;
      }

      const finacialIdCalculated = idSelFinancial ? idSelFinancial : responseData?.finacialIdCalculated;
      commit("setSimulationResultsFinancialId", Number(finacialIdCalculated));

    } catch (error) {
      launchErrorToast(error);

    }

  },
  async sendEmail({ rootState }, data) {
    //TODO: REFACTOR ALERT - juntar ao printFin. Extrair payload para uma função e usar em ambas as funções - repetição de código (payload)
    const ppc = state.financingInfo.ppcValue;
    const printType = "email";
    const instalationId =
      rootState.AuthenticationModule.instalationsDropdown.find(
        (item) => item.selected
      )?.value;
    const isBBVASpain = state.bbvaSpain;
    // Quando é financeiras espanholas e os rates são tins
    const tinId = state.financingInfo.rate;
    const rateEsText = state.financingInfo?.tin?.find((tin) => tin.value === Number(tinId))?.text;

    if (data.error != "") {
      launchErrorToast(data.error);
    }

    try {
      
      if(state.idCotation && state.idCotation < 0) {
        await store.dispatch("SimulationModule/saveCotation");
      }

      const payload = payloadPrintCotation(data, isBBVASpain, instalationId, ppc, rateEsText, printType, rootState);

      if (data.error == "") {
        const response = await postEmail(payload);
        
        let contentType = response?.response?.headers["content-type"];
        if (contentType?.includes("application/json")) {
          const text = new TextDecoder().decode(response?.response?.data);
          const json = JSON.parse(text);
          launchErrorToast(json?.data || "Erro ao gerar Folha Cotação/FIN!");
          return;
        }

        console.log("mail enviado! ", response);
      }

    } catch (error) {
      console.log(error);
    }

  },
  async printFin({ rootState }, data) {
    //TODO: REFACTOR ALERT - juntar ao sendEmail. Extrair payload para uma função e usar em ambas as funções - repetição de código (payload)
    const ppc = state.financingInfo.ppcValue;
    const printType = "pdf";
    const instalationId =
      rootState.AuthenticationModule.instalationsDropdown.find(
        (item) => item.selected
      )?.value;
    const isBBVASpain = state.bbvaSpain;
    // Quando é financeiras espanholas e os rates são tins
    const tinId = state.financingInfo.rate;
    const rateEsText = state.financingInfo?.tin?.find((tin) => tin.value === Number(tinId))?.text;

    try {

      if(state.idCotation && state.idCotation < 0) {
        await store.dispatch("SimulationModule/saveCotation");
      }

      const payload = payloadPrintCotation(data, isBBVASpain, instalationId, ppc, rateEsText, printType, rootState);

      //TODO: acrescentar novo endpoint por financeira ES ou PT BBVA SPAIN OR SOFINCO
      //TODO: adicionar variavel - condição
      const response = await postFin(payload);
      
      let contentType = response?.response?.headers["content-type"];
      if (contentType?.includes("application/json")) {
        const text = new TextDecoder().decode(response?.response?.data);
        const json = JSON.parse(text);
        launchErrorToast(json?.data || "Erro ao gerar Folha Cotação/FIN!");
        return;
      }

      contentType = response?.headers["content-type"];
      const currentTimeInMillis = Date.now();

      // É PDF — converter arraybuffer para Blob
      const blobPDF = new Blob([response.data], { type: contentType });
      downloadFile(blobPDF, 'COT_FIN_' + currentTimeInMillis);

    } catch (error) {
      console.log(error);
    }

  },
  async saveCotation({ rootState }) {
    const userId = rootState.AuthenticationModule.userDetails?.ID;
    const ppc = state.financingInfo.ppcValue;
    const ppcNumber = state.financingInfo.ppcNrValue;
    const instalationId =
      rootState.AuthenticationModule.instalationsDropdown.find(
        (item) => item.selected
      )?.value;
    const idSelFinancial = state.financingInfo.selectedFin?.value;
    const isBBVASpain = state.bbvaSpain;
    const idProduct = state.financingInfo.selectedProd?.value;

    try {
      const payload = {
        "idProduct": Number(idProduct),
        "idUser": userId,
        "currentEntity": Number(instalationId),
        "periodicity": state.financingInfo?.periodicity?.id === 1 ? "Mensal" : "Trimestral",
        "rateType": state.financingInfo?.interestRate?.id === 1 ? "Fixa" : "Indexada",
        "clientType": Number(state.clientInfo?.clientType),
        "isENICompany": state.clientInfo?.isENICompany,
        "salesman": state.sellerInfo?.seller,
        "emailSalesman": state.sellerInfo?.emailSeller,
        "idFinancial": Number(idSelFinancial),
        "expensesFinance": state.financingInfo?.withFinancedExpenses.id === 1
          ? "S"
          : "N",
        "taxstampFinance": state.financingInfo?.withFinancedTax.id === 1
          ? "S"
          : "N",
        "ppcName": ppc.value === -1 ? "" : ppc.text,
        "clientFirstName": state.clientInfo?.firstName,
        "clientFirstSurname": state.clientInfo?.firstSurname,
        "clientSecondSurname": state.clientInfo?.secondSurname,
        "clientbirthdate": state.clientInfo?.birthdate,
        "clientphone": state.clientInfo?.phoneNumber,
        "clientemail": state.clientInfo?.email,
        "clientobs": state.clientInfo?.notes,
        "pvp": Number(state.financingInfo?.pvp),
        "maintenance_contract": 0,
        "warranty_extra": 0,
        ...(isBBVASpain && {
          "rate_es": Number(state.financingInfo?.rate)
        }),
        ...(!isBBVASpain && {
          "rate": Number(state.financingInfo?.rate)
        }),
        "initialvalueeur": Number(state.financingInfo?.initialEntry),
        "hidden_capitalfinanciado": Number(state.simulationResults?.capitalToFinance),
        ...(isBBVASpain && {
          "nrpayments_es": Number(state.financingInfo?.period),
        }),
        ...(!isBBVASpain && {
          "nrpayments": Number(state.financingInfo?.period),
        }),
        "residualvalueeur":
          state.financingInfo?.residualValue == ""
            ? 0
            : Number(state.financingInfo?.residualValue),
        "hidden_prestacao": Number(state.simulationResults?.fee),
        "comcaucao": state.financingInfo?.withBail.id === 1
          ? "S"
          : "N",
        "caucao": Number(state.simulationResults?.guarantee),
        "expenses": Number(state.financingInfo?.expenses),
        "legalTax": Number(state.financingInfo?.legalTax),
        "legalTaxInvoicedTo": getLegalTaxInvoicedTo(state, rootState),
        "hidden_valorselo": Number(state.simulationResults?.taxStamp),
        "hidden_taeg": Number(state.simulationResults?.taeg),
        "hidden_firstpayment": Number(state.simulationResults?.firstPayment),
        "lackperiod": 0,
        "differentialfee_nrmonths": 0,
        "differentialfee_value": 0,
        "hidden_ppc": Number(state.simulationResults?.singlePPCValue),
        "insurance_ppcnrinsuredpeople": ppcNumber.value === -1 ? 0 : Number(ppcNumber.text),
        "hidden_rewardfinancial": Number(state.simulationResults?.rewardFinancial),
        "hidden_rewardexpenses": Number(state.simulationResults?.rewardInitialExpenses),
        "hidden_rewardppc": Number(state.simulationResults?.cleanPPCTotalValue),
        "hidden_rewardincrementalmonth1": Number(state.simulationResults?.rewardIncrementalMonth1),
        "hidden_rewardincrementalmonth2": Number(state.simulationResults?.rewardIncrementalMonth1),
        "cartype": state.vehicleInfo.vehicleCondition?.id === 1
          ? "Novo"
          : "Usado",
        "caryear": state.vehicleInfo?.plateYear?.value === -1
          ? 0
          : Number(state.vehicleInfo?.plateYear?.text),
        "carmonth": state.vehicleInfo?.plateMonth?.value === -1
          ? 0
          : Number(state.vehicleInfo?.plateMonth?.text),
        "carday": state.vehicleInfo?.plateDay?.value === -1
          ? 1
          : Number(state.vehicleInfo?.plateDay?.text),
        "category": state.vehicleInfo?.vehicleType,
        "aux_eurotaxbrand": state.vehicleInfo?.brand,
        "eurotaxmodel": state.vehicleInfo?.modelExt || state.vehicleInfo?.model,
        "aux_eurotaxversion": state.vehicleInfo?.version !== "" ? state.vehicleInfo?.version.split("|")[0] : state.vehicleInfo?.version,
        "tylacode": state.vehicleInfo?.euroTaxCode,
        "eurotaxgrossweight": state.vehicleInfo?.grossWeight,
        "eurotaxfueltype": state.vehicleInfo?.fuel,
        "eurotaxhp": state.vehicleInfo?.enginePower,
        "eurotaxdisplacement": state.vehicleInfo?.displacementEngine,
        "eurotaxnrdoors": Number(state.vehicleInfo?.doors),
        "eurotaxseats": Number(state.vehicleInfo?.places)
      }
      const response = await saveCotation(payload);
      store.commit("SimulationModule/setIdCotation", response.data.data.id, { root: true });
      store.commit("SimulationModule/setCotationData", response.data.data, { root: true });

      if (response.status === 200) {
        Vue.$toast.open({
          message: i18n.t("pages.SimulatorPage.onSaveCotation.success"),
          dismissible: true,
          type: "success"
        });
      } else {
        launchErrorToast(i18n.t("pages.SimulatorPage.onSaveCotation.error"))
      }
    } catch (error) {
      console.log(error);
    }

  },
  async fetchSellersTax({ commit, rootState }, sellersTableNumber) {
    const instalationId =
      rootState.AuthenticationModule.instalationsDropdown.find(
        (item) => item.selected
      )?.value;
    const isVehicleUsed =
      state.vehicleInfo.vehicleCondition?.id === 2 ? true : false;
    const idProduct = state.financingInfo.selectedProd?.value;
    const idSelFinancial = state.financingInfo.selectedFin?.value;
    const ppc = state.financingInfo.ppcValue;

    const ppcNumber = state.financingInfo.ppcNrValue;

    try {
      const payload = {
        "idEntity": Number(instalationId),
        "cartype": state.vehicleInfo.vehicleCondition?.id === 1
          ? "Novo"
          : "Usado",
        "eurotaxbrand": state.vehicleInfo?.brand,
        ...(isVehicleUsed && { caryear: Number(state.vehicleInfo?.plateYear?.text) }),
        "product": Number(idProduct),
        "ratetype": state.financingInfo?.interestRate?.id === 1 ? "Fixa" : "Indexada",
        "nrpayments": Number(state.financingInfo?.period),
        "financial": Number(idSelFinancial),
        "salesmantable": sellersTableNumber,
        "clienttype": state.clientInfo?.clientType,
        "initialvalueeur": Number(state.financingInfo?.initialEntry),
        "periodicity": state.financingInfo?.periodicity?.id === 1 ? "Mensal" : "Trimestral",
        "pvp": Number(state.financingInfo?.pvp),
        "expenses": Number(state.financingInfo?.expenses),
        "expensesFinance": state.financingInfo?.withFinancedExpenses.id === 1
          ? "S"
          : "N",
        "taxStampFinance": state.financingInfo?.withFinancedTax.id === 1
          ? "S"
          : "N",
        "ppc": ppc.value === -1 ? "" : ppc.text,
        "legalTaxInvoicedTo": getLegalTaxInvoicedTo(state, rootState),
      };

      commit("setSellersPayloadClone", payload);

      if (validateInputsBeforeFetchSellersTax(state)) {

        return;
      }

      payload["insurance_ppcnrinsuredpeople"] = ppcNumber.value == -1 ? 0 : Number(ppcNumber.text);

      store.commit("SpinnerModule/setLoading", true, { root: true });
      const response = await getSellersTax(payload);
      setTimeout(() => {
        store.commit("SpinnerModule/setLoading", false, { root: true });
      }, 500);

      commit("setFinancingInfoField", {
        field: 'rate',
        value: response?.data?.data,
      });
      

      if(response?.data?.data == 99) {
        launchErrorToast("Não encontrámos nenhuma TAN. POR FAVOR, CONTACTAR O GESTOR DE NEGÓCIO");
      } else {
        response?.data?.data ? launchSuccessToast("Taxa de Juro " + response?.data?.data) : launchErrorToast("Erro no cálculo");
      }

    } catch (error) {
      console.log(error);
    }

  },
  validateBeforeCreateProposal({ state }) {
    clearToasts();
    const { clientInfo, vehicleInfo, sellerInfo } = state;
    const isCompanyType = clientInfo.clientType === 3;
    const ppcValueText = state.financingInfo?.ppcValue?.text;
    let age = 0;
    const birthdate = state.clientInfo?.birthdate;
    let hasError = false;
    const idSelFinancial = state.financingInfo.selectedFin?.value;
    const interestRateID = state.financingInfo?.interestRate?.id;
    const clientType = state.clientInfo?.clientType;
    let annees = 0;
    let avoirPlusDe79ans = false;
    //const isSpainSim = state.bbvaSpain;

    if (birthdate) {
      const birthdateObj = new Date(birthdate);
      const today = new Date();

      age = today.getFullYear() - birthdateObj.getFullYear();

      if (
        today.getMonth() < birthdateObj.getMonth() ||
        (today.getMonth() === birthdateObj.getMonth() && today.getDate() < birthdateObj.getDate())
      ) {
        age--;
      }
    }

    if (state.financingInfo?.period) {
      const period = Number(state.financingInfo?.period);
      // Calcul des années et des mois
      annees = Math.floor(period / 12);
      avoirPlusDe79ans = (annees + age) > 79;
    }

    const checks = [
      {
        check: !clientInfo.firstName,
        message: isCompanyType ? i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.noCompanyName") : i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.noFirstName")
      },
      {
        check: !vehicleInfo.version,
        message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.noVehicleSelected")
      },
      {
        check: clientInfo?.email && testIfItIsNotEmail(clientInfo?.email),
        message: i18n.t("pages.SimulatorPage.simulationError.clientInfoError.email")
      },
      {
        check: clientInfo?.email && testIfItIsNotEmail(clientInfo?.email),
        message: i18n.t("pages.SimulatorPage.simulationError.clientInfoError.email")
      },
      {
        check: ppcValueText === "PPP" && age > 65,
        message: i18n.t("pages.SimulatorPage.simulationError.financingInfoError.pppValidation"),
      },
      {
        check: (idSelFinancial === "4" || idSelFinancial === 4) && interestRateID === 2 && clientType === 1,
        message: i18n.t("pages.SimulatorPage.simulationError.financingInfoError.interestRateSantander"),
      },
      {
        check: (idSelFinancial === "4" || idSelFinancial === 4) && interestRateID === 2 && clientType === 1,
        message: i18n.t("pages.SimulatorPage.simulationError.financingInfoError.interestRateSantander"),
      },
      {
        // Apenas BBVA ES e maior do que 79 + Periodo
        check: avoirPlusDe79ans && idSelFinancial === 12,
        message: i18n.t("pages.SimulatorPage.simulationError.financingInfoError.bbvaEsMoreThan79YearsOld"),
      },
      {
        //#5 O campo vendedor é obrigatório
        check: !sellerInfo.seller || sellerInfo.value === -1,
        message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.noSeller"),
      }
    ];

    if (!isCompanyType) {
      //SIFA-2205 -firstSurname non required
      /*checks.push({
        check: !clientInfo.firstSurname && isSpainSim,
        message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.noFirstSurname")
      });
      checks.push(
        {
          check: !clientInfo.secondSurname,
          message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.noSecondSurname")
        });*/
      checks.push(
        {
          check: !clientInfo.birthdate,
          message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.noBirthdate")
        });
      checks.push(
        {
          check: clientInfo?.birthdateError,
          message: i18n.t("pages.SimulatorPage.simulationError.clientInfoError.birthdate")
        });

      const fullName = !clientInfo.firstName + !clientInfo.secondSurname + clientInfo.firstSurname;
      const fullNameLength = fullName.length;
      if (fullNameLength < 5 || fullNameLength > 97) {
        checks.push({
          check: !fullName,
          message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.fullNameValidationLength")
        });
      }

      if (clientInfo.firstName) {
        const isNotValid = isNotValidLetters(clientInfo.firstName);
        if (isNotValid) {
          checks.push({
            check: clientInfo?.firstName,
            message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.inValidFirstName")
          });
        }
      }

      if (clientInfo.firstSurname) {
        const isNotValid = isNotValidLetters(clientInfo.firstSurname);
        if (isNotValid) {
          checks.push({
            check: clientInfo?.firstSurname,
            message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.inValidFirstSurname")
          });
        }
      }

      if (clientInfo.secondSurname) {
        const isNotValid = isNotValidLetters(clientInfo.secondSurname);
        if (isNotValid) {
          checks.push({
            check: clientInfo?.secondSurname,
            message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.inValidSecondSurname")
          });
        }
      }

    }

    checks.forEach(({ check, message }) => {
      if (check) {
        launchErrorToast(message);
        hasError = true;
      }
    });

    return hasError;
  },
  validateCustomerName({ state }) {
    clearToasts();
    const { clientInfo } = state;
    const isCompanyType = clientInfo.clientType === 3;

    let hasError = false;

    const checks = [];

    if(!clientInfo.firstName) {
      checks.push({
        check: !clientInfo.firstName,
        message: isCompanyType ? i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.noCompanyName") : i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.noFirstName")
      });
    }

    if (!isCompanyType) {
      if(!clientInfo.secondSurname) {
        checks.push({
          check: !clientInfo.secondSurname,
          message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.noSecondSurname")
        });
      }

      const fullName = !clientInfo.firstName + !clientInfo.secondSurname + clientInfo.firstSurname;
      const fullNameLength = fullName.length;
      if (fullNameLength < 5 || fullNameLength > 97) {
        checks.push({
          check: !fullName,
          message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.fullNameValidationLength")
        });
      }

      if (clientInfo.firstName) {
        const isNotValid = isNotValidLetters(clientInfo.firstName);
        if (isNotValid) {
          checks.push({
            check: clientInfo?.firstName,
            message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.inValidFirstName")
          });
        }
      }

      if (clientInfo.firstSurname) {
        const isNotValid = isNotValidLetters(clientInfo.firstSurname);
        if (isNotValid) {
          checks.push({
            check: clientInfo?.firstSurname,
            message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.inValidFirstSurname")
          });
        }
      }

      if (clientInfo.secondSurname) {
        const isNotValid = isNotValidLetters(clientInfo.secondSurname);
        if (isNotValid) {
          checks.push({
            check: clientInfo?.secondSurname,
            message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.inValidSecondSurname")
          });
        }
      }

    }

    checks.forEach(({ check, message }) => {
      if (check) {
        launchErrorToast(message);
        hasError = true;
      }
    });

    return hasError;
  },
  async createProposal({ state, dispatch }) {
    return await dispatch('ProposalsModule/createProposal', state, { root: true });
  },
  async updateProposalData({ commit, state, rootState }, { proposalId, gscCode }) {
    commit("setTableLoading", false);
    const idSelFinancial = state.financingInfo.selectedFin?.value;
    const idProduct = state.financingInfo.selectedProd?.value;
    const ppc = state.financingInfo.ppcValue;
    const ppcNumber = state.financingInfo.ppcNrValue;

    try {
      const payload = {
        "idProposal": proposalId,
        "gscCode": gscCode,
        "financial": idSelFinancial,
        "idCotation": state.idCotation || -1,
        "financialInfo": {
          "idProduct": idProduct,
          "periodicity": state.financingInfo?.periodicity?.id === 1 ? "Mensal" : "Trimestral",
          "rateType": state.financingInfo?.interestRate?.id === 1 ? "Fixa" : "Indexada",
          "expensesFinance": state.financingInfo?.withFinancedExpenses.id === 1
            ? "S"
            : "N",
          "taxstampFinance":
            state.financingInfo?.withFinancedTax.id === 1
              ? "S"
              : "N",
          "pvp": Number(state.financingInfo?.pvp),
          "maintenanceContract": 0,
          "warrantyExtra": 0,
          "rate": Number(state.financingInfo?.rate),
          "initialValueEur": Number(state.financingInfo?.initialEntry),
          "capitalFinanciado": Number(state.simulationResults?.capitalToFinance),
          "nrPayments": Number(state.financingInfo?.period),
          "residualValueEur":
            state.financingInfo?.residualValue == ""
              ? 0
              : Number(state.financingInfo?.residualValue),
          "prestacao": state.simulationResults?.fee,
          "comCaucao": state.financingInfo?.withBail.id === 1
            ? "S"
            : "N",
          "caucao": Number(state.simulationResults?.guarantee),
          "expenses": idSelFinancial === FINANCIAL_IDS.CAIXABANK ? Number(state.simulationResults?.initialExpenses) : Number(state.financingInfo?.expenses),
          "valorSelo": Number(state.simulationResults?.taxStamp),
          "portsExpenses": Number(state.simulationResults?.portsExpenses),
          "taeg": Number(state.simulationResults?.taeg),
          "firstpayment": Number(state.simulationResults?.firstPayment),
          "ppc": ppc.value === -1 ? "" : ppc.text,
          "ppcValue": Number(state.simulationResults?.singlePPCValue),
          "insurancePPCnrInsuredPeople":
            ppcNumber.value === -1 ? 0 : Number(ppcNumber.text),
          "rewardFinancial": Number(state.simulationResults?.rewardFinancial),
          "rewardFinancialDealer": 0,
          "rewardExpenses": Number(state.simulationResults?.rewardInitialExpenses),
          "rewardPPC": Number(state.simulationResults?.PPCReward),
          "rewardIncrementalMonth1": Number(state.simulationResults?.rewardIncrementalMonth1),
          "rewardIncrementalMonth2": Number(state.simulationResults?.rewardIncrementalMonth1),
          "lackperiod": 0,
          "differentialFeeNrMonths": 0,
          "differentialFeeValue": 0,
          "legalTaxInvoicedTo": getLegalTaxInvoicedTo(state, rootState),
        },
        "carInfo": {
          "carType": state.vehicleInfo.vehicleCondition?.id === 1
            ? "Novo"
            : "Usado",
          "carYear": Number(state.vehicleInfo?.plateYear?.text),
          "carMonth": state.vehicleInfo?.plateMonth?.value !== -1 ? Number(state.vehicleInfo?.plateMonth?.text) : 1,
          "carDay": state.vehicleInfo?.plateDay?.value !== -1 ? Number(state.vehicleInfo?.plateDay?.text) : 1,
          "category": state.vehicleInfo?.vehicleType,
          "brand": state.vehicleInfo?.brand,
          "model": state.vehicleInfo?.modelExt || state.vehicleInfo?.model,
          "version": state.vehicleInfo?.version !== "" ? state.vehicleInfo?.version.split("|")[0] : state.vehicleInfo?.version,
          "tylacode": state.vehicleInfo?.euroTaxCode,
          "grossWeight": state.vehicleInfo?.grossWeight,
          "fuelType": state.vehicleInfo?.fuel,
          "hp": state.vehicleInfo?.enginePower,
          "displacement": state.vehicleInfo?.displacementEngine,
          "nrDoors": Number(state.vehicleInfo?.doors),
          "seats": Number(state.vehicleInfo?.places)
        },
        "clientInfo": {
          "clientType": state.clientInfo?.clientType,
          "firstENIType": state.clientInfo?.clientType === 1 ? "Particular" : state.clientInfo?.clientType === 2 ? "ENI" : state.clientInfo?.clientType === 3 ? "Empresa" : "Autónomo",
          "clientFirstName": state.clientInfo?.firstName,
          "clientFirstSurname": state.clientInfo?.firstSurname,
          "clientSecondSurname": state.clientInfo?.secondSurname,
          "clientBirthdate": state.clientInfo?.birthdate ? state.clientInfo?.birthdate : null,
          "clientPhone": state.clientInfo?.phoneNumber,
          "clientEmail": state.clientInfo?.email,
          "clientObs": state.clientInfo?.notes,
          "salesman": state.sellerInfo?.seller,
          "emailSalesman": state.sellerInfo?.emailSeller,
          "isENICompany": state.clientInfo?.isENICompany
        }
      } 
      await updateProposalData(payload);

    } catch (error) {
      console.log(error);
    }

  }
};

const payloadPrintCotation = (data, isBBVASpain, instalationId, ppc, rateEsText, printType, rootState) => {
  const firstSurname = state.clientInfo?.firstSurname ?? '';
  const secondSurname = state.clientInfo?.secondSurname ?? '';
  return {
    "cotation": {
      "capitalToFinance": Number(state.simulationResults?.capitalToFinance),
      "carBrand": state.vehicleInfo?.brand,
      "carCategory": state.vehicleInfo?.vehicleType,
      "carModel": state.vehicleInfo?.modelExt || state.vehicleInfo?.model,
      "carMonth": state.vehicleInfo?.plateMonth?.value === -1
        ? 0
        : Number(state.vehicleInfo?.plateMonth?.text),
      "carTylacode": state.vehicleInfo?.euroTaxCode,
      "carType": state.vehicleInfo.vehicleCondition?.id === 1
        ? "Novo"
        : "Usado",
      "carVersion": state.vehicleInfo?.version !== "" ? state.vehicleInfo?.version.split("|")[0] : state.vehicleInfo?.version,
      "carYear": state.vehicleInfo?.plateYear?.value === -1
        ? 0
        : Number(state.vehicleInfo?.plateYear?.text),
      "customerName": state.clientInfo?.firstName + " " + firstSurname + " " + secondSurname,
      "customerType": state.clientInfo?.clientTypeLabel.startsWith("ENI") ? "ENI" : state.clientInfo?.clientTypeLabel,
      "differentialFeeNrMonths": 0,
      "differentialFeeValue": 0,
      "expenses": Number(state.financingInfo?.expenses),
      "expensesFinance": state.financingInfo?.withFinancedExpenses.id === 1
        ? "S"
        : "N",
      "feeWithoutInsurence": Number(
        state.simulationResults?.feeWithoutInsurence
      ),
      "firstPayment": Number(state.simulationResults?.firstPayment),
      "guarantee": Number(state.simulationResults?.guarantee),
      "idFinancial": Number(state.financingInfo.selectedFin?.value),
      "idProduct": Number(state.financingInfo.selectedProd?.value),
      "idCurrentEntity": Number(instalationId),
      "initialEntrance": Number(state.financingInfo?.initialEntry),
      "initialExpenses": Number(state.simulationResults?.initialExpenses),
      "insurancePpcName": ppc.value === -1 ? "" : ppc.text,
      "insurancePpcValue": Number(state.simulationResults?.singlePPCValue),
      "lackPeriod": 0,
      "maintenanceContract": 0,
      "legalTax": Number(state.financingInfo?.legalTax),
      "legalTaxInvoicedTo": getLegalTaxInvoicedTo(state, rootState),
      "period": Number(state.financingInfo?.period),
      "periodicity": state.financingInfo?.periodicity?.id === 1 ? "Mensal" : "Trimestral",
      "portsExpenses": Number(state.simulationResults?.portsExpenses),
      "price": Number(state.financingInfo?.pvp),
      "productName": state.financingInfo.selectedProd?.text,
      "rate": isBBVASpain ? Number(rateEsText) : Number(state.financingInfo?.rate),
      "rateType": state.financingInfo?.interestRate?.id === 1 ? "Fixa" : "Indexada",
      "residualValue": state.financingInfo?.residualValue == ""
        ? 0
        : Number(state.financingInfo?.residualValue),
      "taeg": Number(state.simulationResults?.taeg),
      "taxStamp": Number(state.simulationResults?.taxStamp),
      "taxStampFinance": state.financingInfo?.withFinancedTax.id === 1
        ? "S"
        : "N",
      "warrantyExtra": 0,
      "cotationId": state.idCotation
    },
    "printType": printType,
    "entryValue": Number(data.sinal),
    "emailTo": data.email,
    "emailBody": data.message,
    "isENICompany": state.clientInfo?.isENICompany
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
